import { InfoOutlined } from '@mui/icons-material';
import { Box, styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const HtmlTooltipContent = ({ html }: { html: string }) => (
    <Box
        sx={{
            '& p': { my: 0.5 },
            '& ul, & ol': { margin: '4px 0', paddingLeft: '18px' },
            '& li': { margin: '2px 0' },
            '& a': {
                color: '#6d41d8',
                textDecoration: 'underline',
                '&:hover': { color: '#8353e2' },
            },
        }}
        dangerouslySetInnerHTML={{ __html: html }}
    />
);

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
    },
}));

interface Props {
    title: string;
    tooltipContent?: string;
    /** Ellipsize the label and keep the info icon inside the available width. */
    truncate?: boolean;
}

const TitleTooltip = ({ title, tooltipContent, truncate = false }: Props) => {
    const icon = tooltipContent ? (
        <LightTooltip placement="top" title={<HtmlTooltipContent html={tooltipContent} />}>
            <InfoOutlined fontSize="small" color="inherit" />
        </LightTooltip>
    ) : null;

    if (!truncate) {
        return (
            <>
                {title}&nbsp;
                {icon}
            </>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
            <Box
                component="span"
                title={title}
                sx={{
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {title}
            </Box>
            {icon ? <Box sx={{ display: 'inline-flex', flexShrink: 0 }}>{icon}</Box> : null}
        </Box>
    );
};

export default TitleTooltip;
